import {generalRequest} from "@/lib/services/requests";
import {useQuery} from "@tanstack/react-query";
import {myAcademy} from "@/lib/services/academyService";
import {current_hours} from "@/lib/helper/date";

export function useApiReadStudentDashboard() {
    return useQuery({
        queryKey: ['api', 'student', 'dashboard', current_hours(), myAcademy()],
        queryFn: () => ((() => {
            return generalRequest.get(`student/dashboard`)
        })())
    })
}


export function useApiReadAdminDashboard() {
    return useQuery({
        queryKey: ['api', 'admin', 'dashboard', current_hours(), myAcademy()],
        queryFn: () => ((() => {
            return generalRequest.get(`admin/dashboard`)
        })())
    })
}


export function useApiReadTeacherDashboard() {
    return useQuery({
        queryKey: ['api', 'teacher', 'dashboard', current_hours(), myAcademy()],
        queryFn: () => ((() => {
            return generalRequest.get(`teacher/dashboard`)
        })())
    })
}


export function useApiReadTeacherWeeklyClass() {
    return useQuery({
        queryKey: ['api', 'teacher', 'weekly-class', current_hours(), myAcademy()],
        queryFn: () => ((() => {
            return generalRequest.get(`teacher/lessons-weekly`)
        })())
    })
}
